import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { GenericResolverResolver } from '@app/core/resolvers/generic-resolver.resolver';
import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import { Store } from '@ngxs/store';
import { map } from 'rxjs/operators';

import { Program } from '../models/programs.model';
import { ProgramsRequest } from '../states/programs.actions';
import { ProgramsState } from '../states/programs.state';

@Injectable({
  providedIn: 'root',
})
export class ProgramFindResolver extends GenericResolverResolver<Program> {
  constructor(router: Router, store: Store) {
    super(
      router,
      store,
      'programId',
      store.select(ProgramsState.programsLoaded).pipe(
        map(loaded => {
          if (!loaded) {
            this.getPrograms();
          }

          return loaded;
        }),
      ),
      ProgramsState.programs,
    );
  }

  getUrl(currentRadioId: number): any[] {
    return ['radio', currentRadioId, 'scheduler', 'programs'];
  }

  @Dispatch()
  getPrograms() {
    return new ProgramsRequest();
  }
}
